export const SAVE_INITIAL_VALUES = 'SAVE_INITIAL_VALUES';
export const SAVE_ROUTE_INFO = 'SAVE_ROUTE_INFO';
export const SAVE_ORCHESTRATION_CACHE = 'SAVE_ORCHESTRATION_CACHE';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const REQUEST_CART_ITEMS = 'REQUEST_CART_ITEMS';
export const RECEIVE_CART_ITEMS = 'RECEIVE_CART_ITEMS';
export const APP_INITIALIZED = 'APP_INITIALIZED';
export const REQUEST_PROFILE = 'REQUEST_PROFILE';
export const RECEIVE_PROFILE = 'RECEIVE_PROFILE';
export const HANDLE_UTAG_EVENT = 'HANDLE_UTAG_EVENT';
export const GET_CUSTOMER_INFO = 'GET_CUSTOMER_INFO';
export const RANDOMIZE_BANNER = 'RANDOMIZE_BANNER';
export const RANDOMIZING_BANNER = 'RANDOMIZING_BANNER';
export const SET_TRACER_VALUE = 'SET_TRACER_VALUE';
export const POLL_UTAG = 'POLL_UTAG';
export const FIRE_UTAG = 'FIRE_UTAG';
export const USER_INITIALIZED = 'USER_INITIALIZED';
export const GOOGLE_MAPS_READY = 'GOOGLE_MAPS_READY';
export const NAVIGATION_LOADED = "NAVIGATION_LOADED";
export const RECIEVE_SIMPLE_INFO_MODAL = 'RECIEVE_SIMPLE_INFO_MODAL';

import { isEmployee } from '../utils/loginUtils';

export function navigationLoaded(navData) {
    return {
        type: NAVIGATION_LOADED,
        payload: navData
    };
}

/**
 * Save initial data to redux store
 * @param  {object} routeInfo    an object containing various info about the current route
 * @return {object}              an object that describes the updates to be made to the store
 */
export function saveRouteInfo(routeInfo) {
    return {
        type: SAVE_ROUTE_INFO,
        payload: {
            routeInfo: routeInfo,
            receivedAt: Date.now()
        }
    };
}

export function saveInitialValues() {
    return {
        type: SAVE_INITIAL_VALUES
    };
}

export function saveOrchestrationCache(cacheHttpResponse) {
    return {
        type: SAVE_ORCHESTRATION_CACHE,
        payload: {
            cache: cacheHttpResponse
        }
    };
}

export function userLoggedIn(loggedInState) {
    return {
        type: USER_LOGGED_IN,
        payload: {
            loggedIn: loggedInState
        }
    };
}

export function requestCartItems() {
    return {
        type: REQUEST_CART_ITEMS
    };
}

export function receiveCartItems(cartItems) {
    const bagCount = _.get(cartItems, 'meta.totalQuantity', 0);
    const discountableSubtotal = _.get(cartItems, 'priceInfo.discountableSubtotal', 0);
    const cartMeta = _.get(cartItems, 'meta', {});

    return {
        type: RECEIVE_CART_ITEMS,
        payload: {
            count: bagCount,
            discountableSubtotal: discountableSubtotal,
            meta: cartMeta
        }
    };
}

export function appInitialized() {
    return {
        type: APP_INITIALIZED,
        payload: {
            initialized: true
        }
    };
}

export function requestProfile(method) {
    return {
        type: REQUEST_PROFILE,
        payload: {
            method: method
        }
    };
}

export function receiveProfile(profile) {
    return {
        type: RECEIVE_PROFILE,
        payload: Object.assign({}, profile, { isEmployee: isEmployee(profile) })
    };
}

export function recieveSimpleInfoModalData(simpleInfoModal) {
    return {
        type: RECIEVE_SIMPLE_INFO_MODAL,
        payload: simpleInfoModal
    };
}

export function handleUtagEvent(utagData, eventType, endTime) {
    return {
        type: HANDLE_UTAG_EVENT,
        payload: {
            data: utagData,
            event: eventType,
            endTime: endTime
        }
    };
}

export function getCustomerInfo() {
    return {
        type: GET_CUSTOMER_INFO
    };
}

export function randomizeBanner(banner) {
    return {
        type: RANDOMIZE_BANNER,
        payload: banner
    };
}

export function setTracerValue(tracerValue) {
    return {
        type: SET_TRACER_VALUE,
        payload: {
            tracerValue: tracerValue
        }
    };
}

export function pollUtag(endTime, utagPayload) {
    return {
        type: POLL_UTAG,
        payload: {
            endTime: endTime,
            data: utagPayload.data,
            event: utagPayload.event
        }
    };
}

export function fireUtag(payload) {
    return {
        type: FIRE_UTAG,
        payload: payload
    };
}

export function userInitialized() {
    return {
        type: USER_INITIALIZED
    };
}

export function readyGoogleMaps() {
    return {
        type: GOOGLE_MAPS_READY
    };
}
